module.exports = __webpack_public_path__ + "static/img/zl2.09d8b31.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/control2/zl2.png
// module id = 4aXa
// module chunks = 7